import { IconCheck } from "@tabler/icons-react"
import { icon } from "../functions/icons"

export function Step({ active, finished, step, title,onClick }) {
    return (
        <div onClick={onClick} data-testid={"step"} className={`horizontal steps-content small-standard-padding small-standard-margin small-rounded standard-small-margin-bottom  ${active && 'active-step active-border heavy-border white-background-color'} ${(finished) && "primary-background-100"} ${!active && 'heavy-border grey-background-100 grey-500'}`}>
            <div className="step text-margin-right">
                <p className={`step-text xsmall-text semi-bold ${(!active && !finished) &&'stepper-inactive'} ${active &&'primary-600'}`}>{step}</p>
            </div>
            <p className={`xsmall-text semi-bold steps-title ${finished &&'primary-600'} ${active &&'primary-600'}`}>{title}</p>
        </div>
    )
}

export function NewStep({status, number, title}) {
    return (
        <div className={`stepper ${status == "completed" ? "completed" : ""} ${status == "disabled" ? "disabled" : ""} ${status == "active" ? "active" : ""}`}>
            <div className="stepper-number">{status == "completed" ? <IconCheck size={14}/> : number}</div>
            <p className="stepper-title">{title}</p>
        </div>
    )
}